import axios from "axios";
import { queryParams } from "../../../utils/queryParams";

const instance = axios.create({
  baseURL: queryParams.apiVersion + "pages/staff_activity/staff_sales_and_conversions/"
});

export const api = {
  getDataPoints(params) {
    return instance.get("get_data_points_values", params);
  },
  getPieCharts(params) {
    return instance.get("get_pie_chart_values", params);
  },
  getTable(params) {
    return instance.get("get_table_values", params);
  }
};
